import { Action, createReducer, on } from '@ngrx/store';

import { initialState, EntityActividadesGrupoEspecieState } from './entity-actividades-grupo-especie.state';
import { entityActividadesGrupoEspecieAdapter } from './entity-actividades-grupo-especie.state';
import {
  entityActividadesGrupoEspecieLoadRequest,
  entityActividadesGrupoEspecieLoadSuccess,
  entityActividadesGrupoEspecieLoadFailure,
  entityActividadesGrupoEspecieAddFailure,
  entityActividadesGrupoEspecieAddRequest,
  entityActividadesGrupoEspecieAddSuccess,
  entityActividadesGrupoEspecieChangeFailure,
  entityActividadesGrupoEspecieChangeRequest,
  entityActividadesGrupoEspecieChangeSuccess,
  entityActividadesGrupoEspecieDeleteFailure,
  entityActividadesGrupoEspecieDeleteRequest,
  entityActividadesGrupoEspecieDeleteSuccess
} from './entity-actividades-grupo-especie.actions';

const reducer = createReducer(
  initialState,
  // load
  on(entityActividadesGrupoEspecieLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityActividadesGrupoEspecieLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityActividadesGrupoEspecieLoadSuccess, (state, { items }) =>
    entityActividadesGrupoEspecieAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // add
  on(entityActividadesGrupoEspecieAddRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityActividadesGrupoEspecieAddFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityActividadesGrupoEspecieAddSuccess, (state, { item }) => 
    entityActividadesGrupoEspecieAdapter.addMany(item, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // change
  on(entityActividadesGrupoEspecieChangeRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityActividadesGrupoEspecieChangeFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityActividadesGrupoEspecieChangeSuccess, (state, { item }) =>
    entityActividadesGrupoEspecieAdapter.updateOne(item, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // delete
  on(entityActividadesGrupoEspecieDeleteRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityActividadesGrupoEspecieDeleteFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityActividadesGrupoEspecieDeleteSuccess, (state, { item }) =>
    entityActividadesGrupoEspecieAdapter.removeOne(item.id, {
      ...state,
      isLoading: false,
      error: null
    })
  )
);

export function actividadesGrupoEspecieReducer(
  state: EntityActividadesGrupoEspecieState | undefined,
  action: Action
) {
  return reducer(state, action);
}
